import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Product } from '../../helpers/types';
import ActionsMenu from '../../sharedComponents/ActionsMenu';
import { UserContext } from '../../../../../context/UserContext';
import { SidekickTablesContext } from '../../helpers/SidekickTablesContext';

export const MobileRowMainContent = ({ data }: { data: Product }) => (
  <Box>
    <Typography variant="body1" fontWeight={600}>
      {data.name || ''}
    </Typography>
  </Box>
);

export const MobileRowExpandableContent = ({
  data,
  currencySymbol,
}: {
  data: Product;
  currencySymbol: string;
}) => {
  const { t } = useTranslation();
  const { categories } = useContext(SidekickTablesContext);

  const category = useMemo(
    () =>
      categories?.find((newCategory) => newCategory.value === data.categoryId?.toString())?.label ||
      'Top Level',
    [currencySymbol, data]
  );
  const salePrice = useMemo(
    () => `${currencySymbol || '£'}${data.salePriceIncTax || 0}`,
    [currencySymbol, data]
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          alignItems: 'flex-start',
          marginRight: '2rem',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.3rem' }}>
          <Typography variant="body1">
            {t('screens.products.sidekick.import.productsTable.description')}:
          </Typography>
          <Typography variant="body1" fontWeight={600}>
            {data.description || ''}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.3rem' }}>
          <Typography variant="body1">{t('screens.products.sidekick.import.productsTable.category')}:</Typography>
          <Typography variant="body1" fontWeight={600}>
            {category}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.3rem' }}>
          <Typography variant="body1">
            {t('screens.products.sidekick.import.productsTable.salePriceIncTax')}:
          </Typography>
          <Typography variant="body1" fontWeight={600}>
            {salePrice}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-end',
        }}
      >
        <ActionsMenu objectId={data.id} />
      </Box>
    </Box>
  );
};
